<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات ورود/خروج تجهیز بهفا</h5>
      <br />

      <br>
      <br>


      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> وضیعت </label>
          <select class="custom-select" [(ngModel)]="Filter_Type_Lap" >
            <option value="1">تجهیز خارج شده ولی وارد  نشده است (تاریخ اعمال نشود) </option>
            <option value="2">تجهیز خارج شده ولی وارد  نشده است (براساس تاریخ دریافت) </option>
            <option value="3">تجهیز خارج شده و وارد شده  است (براساس تاریخ دریافت)</option>
            <option value="4">تجهیز خارج شده و وارد شده  است (براساس تاریخ تحویل)</option>
          </select>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ دریافت	شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..."   class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ دریافت	پایان</label>
          <input type="text" #datepickerInputEnd  placeholder="اینجا تایپ کنید ..."  class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Code BEHFA</label>
          <input [(ngModel)]="Filter_Code"  name="Filter_Code" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="row">

        <div class="form-group col-md-9">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_DeviceBehfa(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>

            <button *ngIf="!Procssing" type="button" routerLink="/DeviceBehfaDownloadForm" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-cloud-upload"></i> خروج تجهیزات بهفا </button>

          <button *ngIf="!Procssing" type="button" routerLink="/DeviceBehfaUploadForm" class="btn btn-warning"
            style="margin-left: 5px;"><i class="fa  fa-cloud-download"></i> ورود تجهیزات بهفا </button>

            <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>





        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> کاشناس </label>
          <app-ExpertCalibrationOption
          (OnBack_ExpertCalibration_Action)="OnGet_ExpertCalibration_Action($event)">

          </app-ExpertCalibrationOption>
        </div>

      </div>



      <br>
      <br>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>Code BEHFA</th>
              <th>نام کاربر</th>
              <th>تاریخ دریافت</th>
              <th>علت خروج</th>
              <th>تاریخ تحویل</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            | paginate
                    : {
                        id: 'DataList_DeviceBehfaTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceBehfa).length
                      }
            ">
              <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td>{{item.username}}</td>
              <td>{{item.downloadDate}}</td>
              <td>{{item.downloadType}}</td>
              <td>{{item.uploadDate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_DeviceBehfaTable" nextLabel="بعدی" previousLabel="قبلی"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>

<ng-template #templateUpload>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> ورود تجهیزات بهفا </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Upload.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> قبل از اسکن QR Code در کادر پایین کلیک کنید <i class="fa fa-arrow-down"></i>
        </label>
        <input [(ngModel)]="QRCodeInput" name="QRCodeInput" type="text"
          style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;" class="form-control EnglishClm"
          placeholder="اینجا کلیک کنید ...">
      </div>
    </div>
    <div class="row" *ngIf="Info_Upload_List.length>0">
      <div class="form-group col-md-12">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>کد تجهیز</th>
                <th>سریال تجهیز</th>
                <th>QR Code</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Info_Upload_List">
                <td>{{Info_Upload_List.indexOf(item)+1}}</td>
                <td>{{item.codeBEHFA}}</td>
                <td>{{item.codeBEHFA}}</td>
                <td>{{item.model}}</td>
                <td>
                  <button (click)="Info_Upload_Remove(Info_Upload_List.indexOf(item))" class="btn btn-danger"><i
                      class="fa fa-remove"></i> حذف </button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


  </div>
  <div class="modal-footer">
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" (click)="QRCodeChangeUpload()" type="submit" [disabled]="Info_Upload_List.length==0"
      class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Upload.hide()">بستن</button>
  </div>
</ng-template>
